/** Registers yamlEditorApiRef natively. */
import {
  createFrontendModule,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  githubAuthApiRef,
} from '@backstage/core-plugin-api';
import {
  yamlEditorApiRef,
  YamlEditorApiClient,
} from '@internal/plugin-yaml-editor';

export default createFrontendModule({
  pluginId: 'app',
  extensions: [
    ApiBlueprint.make({
      name: 'yaml-editor-api',
      params: define =>
        define(
          createApiFactory({
            api: yamlEditorApiRef,
            deps: {
              discoveryApi: discoveryApiRef,
              fetchApi: fetchApiRef,
              githubAuthApi: githubAuthApiRef,
            },
            factory: ({ discoveryApi, fetchApi, githubAuthApi }) =>
              new YamlEditorApiClient({ discoveryApi, fetchApi, githubAuthApi }),
          }),
        ),
    }),
  ],
});
